import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// --------------------------------------------------
// Determine Device Size
// --------------------------------------------------
const mobileMediaQuery = window.matchMedia("(max-width: 1200px)");
let isMobile = mobileMediaQuery.matches;
const handleMobileChange = (e) => {
  isMobile = e.matches;
  const sidebar = document.querySelector("aside");
  if (sidebar) {
    if (!isMobile) {
      sidebar.classList.remove("-translate-x-full");
    } else {
      sidebar.classList.add("-translate-x-full");
    }
  }
};
mobileMediaQuery.addEventListener("change", handleMobileChange);
handleMobileChange(mobileMediaQuery);

// --------------------------------------------------
// DOM Loaded
// --------------------------------------------------
document.addEventListener("DOMContentLoaded", (event) => {

  const sidebar = document.querySelector("aside");
  const triggerBtn = document.querySelector("#trigger");

  // --- 2. Interaction ---
  sidebar.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");
      if (href && href.startsWith("#") && href.length > 1) {
        const targetElement = document.getElementById(href.substring(1));
        if (targetElement) {
          e.preventDefault();
          // Jump immediately without animation
          targetElement.scrollIntoView({ behavior: "auto", block: "start" });
          updateActiveLink(link);
        }
      }
    });
  });

  // --- 3. UI HELPERS ---
  function updateActiveLink(clickedLink) {
    sidebar.querySelectorAll("a").forEach((l) => l.classList.remove("text-yellow-400"));
    clickedLink.classList.add("text-yellow-400");
  }

  // --- 4. CLICK OUTSIDE ---
  document.addEventListener("click", () => {
    sidebar.querySelectorAll("ul ul").forEach((ul) => ul.classList.add("hidden"));
    sidebar.querySelectorAll("li").forEach((li) => li.classList.add("collapsed"));
  });

  // --- 5. TRIGGER & H2 EMBELLISHMENT ---
  if (triggerBtn) {
    triggerBtn.addEventListener("click", (e) => {
      sidebar.classList.toggle("-translate-x-full");
    });
  }

  // --- 6. Add # to titles ---
  document.querySelectorAll("h2").forEach((heading) => {
    const hashSpan = document.createElement("span");
    hashSpan.className = "mr-2 text-white/25 inline-block select-none pointer-events-none";
    hashSpan.textContent = "#";
    heading.prepend(hashSpan);
  });

});